import React,{useEffect,useState} from "react";

import {
    Card,
    Space,
    Avatar,
    Typography,
    Row,
    Col,
    Divider,
    Spin
} from "antd";

import {
    TeamOutlined,
    UserOutlined,
    SolutionOutlined
} from "@ant-design/icons";

import { motion } from "framer-motion";

import api from "../../api/api";
import { useAcademicYear } from "../../AcademicYearContext";

const {Title,Text}=Typography;

const EmployeeCount=({theme})=>{

    const {selectedYear}=useAcademicYear();

    const [loading,setLoading]=useState(false);

    const [counts,setCounts]=useState({
        total_employee:0,
        total_teacher:0,
        total_support_staff:0
    });

    useEffect(()=>{

        if(selectedYear){
            fetchCounts();
        }

    },[selectedYear]);

    useEffect(()=>{

        const updateCounts=()=>{

            if(selectedYear){
                fetchCounts();
            }

        };

        window.addEventListener(
            "employeeCountUpdated",
            updateCounts
        );

        window.addEventListener(
            "academic-year-updated",
            updateCounts
        );

        return()=>{

            window.removeEventListener(
                "employeeCountUpdated",
                updateCounts
            );

            window.removeEventListener(
                "academic-year-updated",
                updateCounts
            );

        };

    },[selectedYear]);

    const fetchCounts=async()=>{

        try{

            setLoading(true);

            const res=await api.get(
                "/employee-count/"
            );

            setCounts(res.data);

        }catch(error){

            console.log(error);

        }finally{

            setLoading(false);

        }

    };

    return(

        <motion.div
            whileHover={{y:-4}}
            transition={{duration:.25}}
        >

            <Card
                bodyStyle={{padding:18}}
                style={{
                    background:theme.card,
                    borderRadius:16,
                    border:`1px solid ${theme.border}`,
                    height:"100%"
                }}
            >

                {

                    loading ?

                    <div
                        style={{
                            display:"flex",
                            justifyContent:"center",
                            padding:30
                        }}
                    >
                        <Spin/>
                    </div>

                    :

                    <>

                        <Space align="center">

                            <Avatar
                                size={56}
                                style={{
                                    background:"#5A0B16",
                                    fontSize:24
                                }}
                            >
                                <TeamOutlined/>
                            </Avatar>

                            <div>

                                <Text
                                    style={{
                                        color:theme.secondary
                                    }}
                                >
                                    Employees
                                </Text>

                                <Title
                                    level={2}
                                    style={{
                                        margin:0,
                                        color:theme.text
                                    }}
                                >
                                    {counts.total_employee}
                                </Title>

                                <Text
                                    style={{
                                        color:"#999"
                                    }}
                                >
                                    Total employees
                                </Text>

                            </div>

                        </Space>

                        <Divider
                            style={{
                                margin:"16px 0"
                            }}
                        />

                        <Row gutter={18}>

                            <Col span={12}>

                                <Space>

                                    <Avatar
                                        style={{
                                            background:"#1677ff"
                                        }}
                                    >
                                        <UserOutlined/>
                                    </Avatar>

                                    <div>

                                        <Text type="secondary">
                                            Support Staff
                                        </Text>

                                        <Title
                                            level={4}
                                            style={{
                                                margin:0,
                                                color:theme.text
                                            }}
                                        >
                                            {counts.total_support_staff}
                                        </Title>

                                    </div>

                                </Space>

                            </Col>

                            <Col span={12}>

                                <Space>

                                    <Avatar
                                        style={{
                                            background:"#8B4513"
                                        }}
                                    >
                                        <SolutionOutlined/>
                                    </Avatar>

                                    <div>

                                        <Text type="secondary">
                                            Teachers
                                        </Text>

                                        <Title
                                            level={4}
                                            style={{
                                                margin:0,
                                                color:theme.text
                                            }}
                                        >
                                            {counts.total_teacher}
                                        </Title>

                                    </div>

                                </Space>

                            </Col>

                        </Row>

                    </>

                }

            </Card>

        </motion.div>

    );

};

export default EmployeeCount;